import countryCodeMap from "../data/country_code_map.json";

export default function getFullAddress(customer) {
  if (customer) {
    return `${customer.addressStreet}, ${customer.addressCity}, ${customer.addressState}, ${customer.addressZipCode}, ${countryCodeMap[customer.addressCountry]}`;
  }
  return "";
}
